export const WEBAPP_URL = process.env.NEXT_PUBLIC_ENV_WEBAPP_HOST_NAME;
export const API_URL = process.env.NEXT_PUBLIC_ENV_API_HOST_NAME;

export const ANDROID_APP_ID = 'org.mpp.cineamo';
export const APPLE_APP_ID = '1447730281';
export const PLAY_STORE_URL = (utmSource: string) =>
    `https://play.google.com/store/apps/details?id=${ANDROID_APP_ID}&referrer=utm_source%3D${utmSource}%26utm_medium%3Dcinema-website%26utm_campaign%3Dwebsite-cta`;
export const APP_STORE_URL = (utmSource: string) =>
    `https://apps.apple.com/app/apple-store/id${APPLE_APP_ID}?pt=120760330&ct=Cineamo-Cinema-Website-Landing-Page-${utmSource}&mt=8`;
